import React, { useState, useEffect } from 'react';
import { Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty, groupBy, uniqBy } from 'lodash';
import moment from 'moment';
import Tabels from '../Tabels';
import * as testAction from '../../../Library/Testing/Store/Testing.action';
import * as action from '../../store/DevelopmentOrder.action';
import * as supplierAction from '../../../Supplier/store/Supplier.action';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import { types } from '../../../../Components/helper';
import NewApproveRejectFooter from '../../../../Components/ApproveRejectFooter/NewApproveRejectFooter';
import ForPreview from '../ForPreview';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import UploadTesting from '../UploadTesting';
import Loader from '../../../../Components/Utility/Loader/Loader';
import FilterBy from '../../../../Components/Utility/FilterAction/FilterBy';
import TopTable from './TopTable';
import ImportedDataTable from '../TestReqComponentDetails/ImportedDataTable';
import AddToLibrary from '../AddToLibrary';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';

function TestingAttributes({ onOpen, toggleTestReq, showData, fromTestingLib, fromProductBom, TestingDeleteAccess }) {
  const { t } = useTranslation('common');
  const Id = useParams();
  const devOrderID = Id.devOrderId;
  const ProductTestingData = useSelector((redState) => redState);
  const { Measuremets, UserDetails, BOMConfigDetails, TestDetails, SuppliersDetails, SystemMastersDetails } = ProductTestingData;
  const { ProductBomList, ProductColourList, ReportList, testingAttributes, testRequirmentData, testingAttributes_Length, searchValueFromTest } = Measuremets;
  const { testList } = TestDetails;
  const { testTypeMaster } = SystemMastersDetails;
  const { userInfo, isSupplierLoggedIn } = UserDetails;
  const loggedInUserId = userInfo.userId;
  const { productDetails, isProductArchived } = BOMConfigDetails;
  const { tier2AndAboveList, tier1List } = SuppliersDetails;
  const dispatch = useDispatch();

  const [pdfModal, setpdfModal] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [colour, setColour] = useState(null);
  const [selectedFilterColour, setSelectedFilterColour] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [savedEdit, setSavedEdit] = useState(true);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showConfirmationReDo, setShowConfirmationReDo] = useState(false);
  const [showForPreview, setShowForPreview] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false);
  const [showAddToLibraryModal, setShowAddToLibraryModal] = useState(false);
  const [codeToSendLibrary, setCodeToSendLibrary] = useState('');
  const [type, setType] = useState(null);
  const [selectedColour, setSelectedColour] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [desc, setDesc] = useState('');
  const [code, setCode] = useState('');
  const [addInfo, setAddInfo] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [reDoStatus, setReDoStatus] = useState('');
  const [currentIndex, setCurrentIndex] = useState([]);
  const [forEditId, setForEditId] = useState('');
  const [sortTable, setSortTable] = useState({
    sortOrder: '',
    sortPropertyName: '',
  });
  const [renewState, setReNewState] = useState({
    documentLibId: [],
    reportIds: [],
    renewName: '',
    renewStatus: [],
    testIds: [],
    showDropZone: true,
  });
  const [state, setState] = useState({
    pageIndex: 1,
    pageSize: 5,
    testAttribute: [],
    hasMore: false,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    searchText: '',
    sortBy: null,
    filterParams: null,
  });
  const [fromRenew, setFromRenew] = useState(false);
  const [showNewRow, setShowNewRow] = useState(false);
  const [forNewOptions, setforNewOptions] = useState([]);
  const [bomOptions, setBomOptions] = useState([]);
  const [colourOptions, setColourOptions] = useState([]);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [expectedExpairy, setExpectedExpairy] = useState('');
  const [selectedTypeTop, setSelectedTypeTop] = useState('');
  const [reportId, setReportId] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [newArrayWithData, setNewArrayWithData] = useState([]);
  const [indexes, setIndexes] = useState([]);
  const [parentIndexes, setParentIndexes] = useState([]);
  const [count, setCount] = useState(0);
  const [testPrice, setTestPrice] = useState(null);
  useEffect(() => {
    const suppArray = [...tier1List, ...tier2AndAboveList];
    const upnewArr = uniqBy(suppArray, (e) => e._id);
    setSupplierOptions([...upnewArr]);
  }, [tier2AndAboveList, tier1List]);
  const initialExicution = async () => {
    setState((ini) => ({
      ...ini,
      loading: true,
    }));

    if (!fromTestingLib) {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData._id,
        bomcomponentLibId: showData.libId,
      };
      await dispatch(action.fetchProductBomTesting(getAttributes));
    } else {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData.libId,
      };
      const brandParams = {
        accessedFrom: '',
        loggedInUserId,
      };
      await dispatch(systemMasterAction.getBrandDetails(brandParams));
      await dispatch(systemMasterAction.getSeasonsDetails({ loggedInUserId }));
      devOrderID && showData.libId && (await dispatch(action.getTestingAtrribute(getAttributes)));
    }
    await Promise.all([
      dispatch(testAction.getAllTest({ searchText: searchValueFromTest })),
      dispatch(action.colourProductTesting({ loggedInUserId })),
      dispatch(supplierAction.fetchTier1SupplierListAction()),
      dispatch(supplierAction.fetchTier2AboveSupplierListAction()),
      dispatch(systemMasterAction.fetchTestTypeMaster()),
    ]);
  };

  useEffect(() => {
    initialExicution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(newArrayWithData)) {
      let c = 0;
      newArrayWithData.forEach((ele) => {
        if (ele?.expandData?.length > 1) {
          c += 1;
        }
      });
      setCount(c);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newArrayWithData]);

  useEffect(() => {
    setState((hasState) => ({
      ...hasState,
      totalRecords: testingAttributes_Length,
      hasMore: testingAttributes_Length > state.testAttribute,
      loading: false,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingAttributes_Length, state.testAttribute]);

  const testingAttributeArray = () => {
    return Array.isArray(testingAttributes) ? [...testingAttributes] : [];
  };

  useEffect(() => {
    const createTestingCodeOptions = async () => {
      if (UserDetails?.userRole === 'User') {
        const supplierList = await dispatch(action.getUserSuppliers());
        const filterTestingData = testList?.filter((item) =>
          supplierList?.suppliers?.some((supplier) => supplier?._id === item?.supplier?._id || item?.supplier === null),
        );
        setforNewOptions(filterTestingData);
      } else {
        setforNewOptions(testList);
      }
    };
    Array.isArray(testingAttributes) && forNewTableData();
    setState((initred) => ({
      ...initred,
      loading: false,
      testAttribute: !isEmpty(testRequirmentData) ? [...testRequirmentData] : testingAttributeArray(),
    }));

    setBomOptions(ProductBomList);
    setColourOptions(ProductColourList);
    createTestingCodeOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testList, ProductBomList, ProductColourList, testingAttributes, testRequirmentData]);

  useEffect(() => {
    if (selectedIdArray.length > 0 && newArrayWithData.length > 0 && selectedIdArray.length === newArrayWithData.length) {
      setSelectAll(true);
    }
  }, [selectedIdArray]);

  const forNewTableData = () => {
    const tempArray = Array.isArray(testingAttributes) && [...testingAttributes];
    const newArr = groupBy(tempArray, (item) => item.code);
    const newArrWithData = [];
    for (const property in newArr) {
      const object = {};
      const Suppliers = [];
      const ColourRefData = [];
      const testReports = [];
      const appRej = [];
      const selectedDates = [];
      const results = [];
      const comments = [];
      object.code = property;
      object.expandData = newArr[property];
      newArr[property].forEach((ele) => {
        object._id = ele?._id;
        object.description = ele?.description;
        object.libId = ele?.libId;
        object.type = ele?.type;
        object.bomComponent = ele?.bomComponent;
        object.createdBy = ele?.createdBy;
        object.createdAt = ele.createdAt;
        object.modifiedBy = ele?.modifiedBy;
        object.updatedAt = ele?.updatedAt;
        object.status = ele?.status;
        object.minPassRate = ele?.minPassRate;
        Suppliers.push(ele?.supplier);
        ColourRefData.push(ele?.colour);
        testReports.push(ele?.testReport);
        object.additionalInformation = ele?.additionalInformation;
        appRej.push(ele?.approveRejectedBy);
        results.push(ele?.result);
        comments.push(ele?.comment);
        selectedDates.push(ele?.selectedDate);
        object.testPrice = ele?.testPrice;
      });
      object.result = results;
      object.supplier = Suppliers;
      object.colour = ColourRefData;
      object.testReport = testReports;
      object.isExpanded = !!(!isEmpty(sortTable.propertyName) && object.expandData.length > 1);
      object.approveRejectedBy = appRej;
      object.comment = comments;
      object.selectedDate = selectedDates;
      newArrWithData.push(object);
    }
    setNewArrayWithData([...newArrWithData]);
  };

  const expandAllData = () => {
    const copyState = [...newArrayWithData];
    const copies = [];
    const elements = [];
    if (isEmpty(indexes)) {
      copyState.forEach((ele, index) => {
        if (ele?.expandData?.length > 1) {
          copies.push(index);
          elements.push(ele.expandData[0]._id);
          ele.isExpanded === false && (ele.isExpanded = true);
        }
      });
      setIndexes([...copies]);
      setParentIndexes([...elements]);
    } else {
      copyState.forEach((ele, index) => {
        if (ele?.expandData?.length > 1) {
          copies.push(index);
          if (ele.isExpanded === true) {
            ele.isExpanded = false;
          }
        }
      });
      setIndexes([]);
      setParentIndexes([]);
    }
  };

  const handleExpand = (index, spliceIndex) => {
    const copyState = [...newArrayWithData];
    const copyParentState = [...parentIndexes];
    const copyindexState = [...indexes];
    if (indexes.includes(index)) {
      copyindexState.splice(spliceIndex, 1);
      copyParentState.splice(spliceIndex, 1);
      setParentIndexes([...copyParentState]);
      setIndexes([...copyindexState]);
      copyState[index].isExpanded = false;
    } else {
      copyState[index].isExpanded = !copyState[index]?.isExpanded;
      setIndexes([...indexes, index]);
      setParentIndexes([...parentIndexes, copyState[index].expandData[0]._id]);
    }
    setNewArrayWithData([...copyState]);
  };

  const undoStatus = async () => {
    await dispatch(action.removeComments({ testCaseIds: [state.testAttribute[reDoStatus]?._id] }, devOrderID, t));
    await initialExicution();
    setShowConfirmationReDo(!showConfirmationReDo);
  };

  useEffect(() => {
    setShowNewRow(false);
    const callData = async () => {
      const params = {
        testCode: selectedTypeTop?.code ? selectedTypeTop?.code : null,
        bomComponent: showData?._id,
        colour: colour?._id ? colour._id : null,
        supplier: supplier?._id ? supplier?._id : null,
        searchText: state.searchText,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
      };
      await dispatch(action.fetchTestReportList(params));
    };
    if (selectedTypeTop && showData._id) {
      callData();
    }
  }, [selectedTypeTop, supplier, colour, dispatch, state?.searchText, state?.pageIndex, state?.pageSize, showData]);

  const addNewTest = async () => {
    setSavedEdit(false);
    if (currentIndex) {
      setType(null);
      setSelectedSupplier(null);
      setSelectedColour(null);
      setSelectedFilterColour(null);
      setCurrentIndex([]);
    }
    fromTestingLib && (await dispatch(action.fetchallProductRefsForBom({ bomComponentId: showData?._id })));
    setShowNewRow(true);
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    if (currentIndex !== -1) setCurrentIndex([]);
    setState((ini) => ({
      ...ini,
      searchLoaded: true,
      searchText: searchValue.trim(),
    }));
  };

  const fromSearch = async () => {
    if (!fromTestingLib) {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData.libId,
        searchText: state.searchText,
        bomcomponentLibId: showData.libId,
      };
      await dispatch(action.fetchProductBomTesting(getAttributes));
    } else {
      const params = {
        testCode: selectedTypeTop?.code ? selectedTypeTop?.code : null,
        bomComponent: showData?._id,
        colour: colour?._id ? colour._id : null,
        supplier: supplier?._id ? supplier?._id : null,
        searchText: state.searchText,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
      };
      if (!isEmpty(selectedTypeTop)) {
        await dispatch(action.fetchTestReportList(params));
      }
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (state.searchLoaded) {
        setSelectedIdArray([]);
        setSelectAll(false);
        fromSearch();
        setState((searchEnd) => ({
          ...searchEnd,
          loading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchText]);

  const handleDelete = async (id) => {
    if (!fromTestingLib) {
      if (id) {
        setDeleteId(id);
        setShowConfirmationPopup(true);
      }
    } else {
      setDeleteId(id);
      setShowConfirmationPopup(true);
    }
    setSelectedIdArray([]);
    setSelectAll(false);
  };

  const forElseChar = () => {
    return {
      testCaseId: selectedTypeTop?._id,
      devOrderIds: selectedIdArray,
      code: selectedTypeTop?.code ? selectedTypeTop?.code : '',
      description: selectedTypeTop?.description ? selectedTypeTop?.description : '',
      result: selectedTypeTop?.result ? selectedTypeTop?.result : '',
      status: selectedTypeTop?.status ? selectedTypeTop?.status : '',
      type: selectedTypeTop?.type ? selectedTypeTop?.type : '',
      minPassRate: selectedTypeTop?.minPassRate ? selectedTypeTop?.minPassRate : '',
      bomComponent: showData?._id,
      supplier: supplier?._id ? supplier?._id : null,
      colour: colour?._id ? colour?._id : null,
      comment: selectedTypeTop?.comment ? selectedTypeTop?.comment : '',
      approveRejectedBy: selectedTypeTop?.approveRejectedBy?._id ? selectedTypeTop?.approveRejectedBy?._id : '',
      additionalInformation: selectedTypeTop?.additionalInformation ? selectedTypeTop?.additionalInformation : '',
      testPrice: selectedTypeTop?.testPrice ? selectedTypeTop?.testPrice : '',
    };
  };

  const fromIfChar = (ele) => {
    return {
      testCaseId: selectedTypeTop?._id,
      devOrderIds: [ele._id], // selected Id
      code: selectedTypeTop?.code ? selectedTypeTop?.code : '',
      description: selectedTypeTop?.description ? selectedTypeTop?.description : '',
      result: selectedTypeTop?.result ? selectedTypeTop?.result : '',
      status: selectedTypeTop?.status ? selectedTypeTop?.status : '',
      type: selectedTypeTop?.type ? selectedTypeTop?.type : '',
      minPassRate: selectedTypeTop?.minPassRate ? selectedTypeTop?.minPassRate : '',
      bomComponent: showData?._id,
      supplier: supplier?._id ? supplier?._id : null,
      colour: colour?._id ? colour?._id : null,
      comment: selectedTypeTop?.comment ? selectedTypeTop?.comment : '',
      approveRejectedBy: selectedTypeTop?.approveRejectedBy?._id ? selectedTypeTop?.approveRejectedBy?._id : '',
      additionalInformation: selectedTypeTop?.additionalInformation ? selectedTypeTop?.additionalInformation : '',
      testPrice: selectedTypeTop?.testPrice ? selectedTypeTop?.testPrice : '',
    };
  };

  const hanldeUpdate = async (ele, id) => {
    let params = {};
    if (id !== null) {
      params = fromIfChar(ele);
    } else {
      params = forElseChar();
    }
    await dispatch(action.updateTestingRequirment(params, t));
    const getAttributes = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      devOrderId: devOrderID,
      bomComponent: showData.libId,
    };
    await dispatch(action.getTestingAtrribute(getAttributes));
    const listparams = {
      testCode: selectedTypeTop?.code ? selectedTypeTop?.code : null,
      bomComponent: showData?._id,
      colour: colour?._id ? colour._id : null,
      supplier: supplier?._id ? supplier?._id : null,
    };
    setSelectAll(false);
    setSelectedIdArray([]);
    !isEmpty(selectedTypeTop) && (await dispatch(action.fetchTestReportList(listparams)));
  };

  const fromIfDelete = async (selectedDeleteId) => {
    const params = { devOrderId: devOrderID };
    if (deleteId) {
      state.testAttribute.forEach((allEle) => {
        // newArrayWithData.forEach((allEle) => {
        if (allEle._id === deleteId) {
          selectedDeleteId = allEle.libId;
        }
      });
      params.testCaseIds = [deleteId];
      params.testLibIds = [selectedDeleteId];
    } else {
      selectedIdArray.forEach((eleForDel) => {
        state.testAttribute.forEach((testEle) => {
          // newArrayWithData.forEach((testEle) => {
          if (testEle._id === eleForDel) {
            selectedDeleteId.push(testEle.libId);
          }
        });
      });
      params.testCaseIds = [...selectedIdArray];
      params.testLibIds = [...selectedDeleteId];
    }
    const res = await dispatch(action.deleteTesting(params, t));
    res && (await initialExicution());
  };

  const additionalParamsForIf = (params, selectedDeleteId, selectedDeleteLibId, selectedDeleteColId, selectedDeleteSuppId) => {
    params.testCaseId = selectedTypeTop._id;
    params.devOrderIds = [selectedDeleteId];
    params.bomComponent = selectedDeleteLibId || null;
    params.supplier = selectedDeleteSuppId || null;
    params.colour = selectedDeleteColId || null;
  };

  const additionalParamsForElse = (params, selectedDeleteId, selectedDeleteLibId, selectedDeleteColId, selectedDeleteSuppId) => {
    params.testCaseId = selectedTypeTop._id;
    params.devOrderIds = [...selectedDeleteId];
    params.bomComponent = selectedDeleteLibId || null;
    params.supplier = selectedDeleteSuppId || null;
    params.colour = selectedDeleteColId || null;
  };

  const fromElseDelete = async (selectedDeleteId) => {
    const params = {};
    let selectedDeleteLibId = [];
    let selectedDeleteSuppId = [];
    let selectedDeleteColId = [];
    if (deleteId) {
      state.testAttribute.forEach((allElements) => {
        if (allElements._id === deleteId) {
          selectedDeleteId = allElements._id;
          selectedDeleteLibId = showData?._id;
          selectedDeleteSuppId = supplier?._id;
          selectedDeleteColId = selectedColour?._id;
        }
      });
      additionalParamsForIf(params, selectedDeleteId, selectedDeleteLibId, selectedDeleteColId, selectedDeleteSuppId);
    } else {
      selectedIdArray.forEach((eleForDel) => {
        state.testAttribute.forEach((testEle) => {
          if (testEle._id === eleForDel) {
            selectedDeleteId.push(testEle._id);
            selectedDeleteLibId = showData?._id;
            selectedDeleteSuppId = supplier?._id;
            selectedDeleteColId = selectedColour?._id;
          }
        });
      });
      additionalParamsForElse(params, selectedDeleteId, selectedDeleteLibId, selectedDeleteColId, selectedDeleteSuppId);
    }
    const response = await dispatch(action.deleteTestingRequirments(params, t));
    response && (await initialExicution());
  };

  const deleteById = async () => {
    setShowConfirmationPopup(!showConfirmationPopup);
    setState((deleteState) => ({
      ...deleteState,
      loading: true,
    }));
    const selectedDeleteId = [];
    if (!fromTestingLib) {
      fromIfDelete(selectedDeleteId);
    } else {
      fromElseDelete(selectedDeleteId);
    }
    setSelectAll(false);
    setSelectedIdArray([]);
    setState((deleteStateEnd) => ({
      ...deleteStateEnd,
      loading: false,
    }));
  };

  const deleteColourType = (id) => {
    setDeleteId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of state.testAttribute) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (isEmpty(findItems)) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];
    if (e.target.checked) {
      setSelectedIdArray([...selectedItems, id]);
    } else {
      setSelectAll(false);
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    }
  };

  const onSortColumn = async (e) => {
    let sortBy = {};
    if (sortTable.value === '' || sortTable.value === 'Desc' || sortTable.propertyName !== e) {
      sortBy = {
        sortOrder: 'Asc',
        propertyName: e,
        searchText: state.searchText,
      };
      setSortTable(sortBy);
    } else {
      sortBy = {
        sortOrder: 'Desc',
        propertyName: e,
        searchText: state.searchText,
      };
      setSortTable(sortBy);
    }
    setState((iState) => ({
      ...iState,
      sortBy,
      pageIndex: 1,
      productTest: [],
      totalRecords: null,
    }));

    if (!fromTestingLib) {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData.libId,
        searchText: state.searchText,
        ...sortBy,
        bomcomponentLibId: showData.libId,
      };
      await dispatch(action.fetchProductBomTesting(getAttributes));
    } else {
      const params = {
        testCode: selectedTypeTop?.code ? selectedTypeTop?.code : null,
        bomComponent: showData?._id,
        colour: colour?._id ? colour._id : null,
        supplier: supplier?._id ? supplier?._id : null,
        searchText: state.searchText,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        sortBy,
      };
      if (!isEmpty(selectedTypeTop)) {
        await dispatch(action.fetchTestReportList(params));
      }
    }
  };

  const handleCancle = async (cancelindex) => {
    if (state?.testAttribute[cancelindex]?._id) {
      setCurrentIndex([]);
      setSelectedColour(null);
      setSelectedSupplier(null);
      setSelectedFilterColour(null);
      setType(null);
    } else {
      setCurrentIndex([]);
      setSelectedColour(null);
      setSelectedSupplier(null);
      setSelectedFilterColour(null);
      setType(null);
      const TempArray = JSON.parse(JSON.stringify(state.testAttribute));
      const NewArray = TempArray.filter((filEle) => filEle._id);
      setState((initred) => ({
        ...initred,
        testAttribute: [...NewArray],
        searchText: '',
      }));
    }
    setShowNewRow(false);
    if (fromTestingLib) {
      const listparams = {
        testCode: selectedTypeTop?.code ? selectedTypeTop?.code : null,
        bomComponent: showData?._id,
        colour: colour?._id ? colour._id : null,
        supplier: supplier?._id ? supplier?._id : null,
      };
      await dispatch(action.fetchTestReportList(listparams));
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData.libId,
      };
      devOrderID && (await dispatch(action.getTestingAtrribute(getAttributes)));
    } else {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData.libId,
        bomcomponentLibId: showData.libId,
      };
      await dispatch(action.fetchProductBomTesting(getAttributes));
    }
  };

  const handleSave = async (saveItem, saveIndex, saveChildIndex) => {
    const emptyFields = await (saveItem
      ? saveItem.code === null ||
        saveItem.code === '' ||
        saveItem.description === null ||
        saveItem.description === '' ||
        saveItem.minPassRate === null ||
        saveItem.minPassRate === '' ||
        saveItem.type === null ||
        saveItem.type === ''
      : state.testAttribute[saveIndex].code === null ||
        state.testAttribute[saveIndex].code === '' ||
        state.testAttribute[saveIndex].description === null ||
        state.testAttribute[saveIndex].description === '' ||
        state.testAttribute[saveIndex].minPassRate === null ||
        state.testAttribute[saveIndex].minPassRate === '' ||
        state.testAttribute[saveIndex].type === null ||
        state.testAttribute[saveIndex].type === '');
    if (!emptyFields) {
      await forUpdate(saveItem, saveIndex);
    } else {
      await onNewEntery(saveIndex);
    }
  };

  const forIfUpdateScenario = async (updateItem) => {
    if (updateItem._id) {
      setState((updateState) => ({
        ...updateState,
        loading: true,
      }));
      const putid = updateItem._id;
      const putParams = {
        devOrderId: devOrderID,
        additionalInformation: updateItem?.additionalInformation,
        code: updateItem.code,
        description: updateItem.description,
        minPassRate: updateItem.minPassRate,
        type: updateItem?.type,
        colour: selectedColour?._id,
        bomComponent: showData.libId,
        supplier: selectedSupplier?._id,
        testPrice: updateItem?.testPrice,
      };
      const res = await dispatch(action.updateTesting(putParams, putid, t));
      setCurrentIndex([]);
      setSelectedColour(null);
      setSelectedSupplier(null);
      setSelectedFilterColour(null);
      setType(null);
      await initialExicution();
      if (res) {
        setState((uploadState) => ({
          ...uploadState,
          loading: false,
          searchText: '',
        }));
      }
    } else {
      setState((postState) => ({
        ...postState,
        loading: true,
      }));
      const postParams = {
        devOrderId: devOrderID,
        additionalInformation: updateItem?.additionalInformation ? updateItem?.additionalInformation : '',
        code: updateItem?.code,
        description: updateItem?.description,
        minPassRate: updateItem?.minPassRate,
        type: updateItem?.type,
        bomComponent: showData?.libId,
        colour: selectedColour?._id,
        supplier: selectedSupplier?._id,
        testPrice: updateItem?.testPrice,
      };
      await dispatch(action.addProductTest(postParams, t));
      setCurrentIndex([]);
      setSelectedColour(null);
      setSelectedSupplier(null);
      setSelectedFilterColour(null);
      setType(null);
      await initialExicution();
      setState((postStateEnd) => ({
        ...postStateEnd,
        loading: false,
        searchText: '',
      }));
    }
  };

  const forUpdate = async (updateItem, updateIndex) => {
    if (updateItem) {
      forIfUpdateScenario(updateItem);
    } else if (state?.testAttribute[updateIndex]?._id) {
      setState((updateState) => ({
        ...updateState,
        loading: true,
      }));
      const putid = state.testAttribute[updateIndex]?._id;
      const putParams = {
        devOrderId: devOrderID,
        additionalInformation: state.testAttribute[updateIndex]?.additionalInformation,
        code: state.testAttribute[updateIndex]?.code,
        description: state.testAttribute[updateIndex].description,
        minPassRate: state.testAttribute[updateIndex].minPassRate,
        type: state.testAttribute[updateIndex]?.type,
        colour: state.testAttribute[updateIndex]?.colour?._id,
        bomComponent: showData.libId,
        testPrice: state.testAttribute[updateIndex].testPrice,
      };
      const res = await dispatch(action.updateTesting(putParams, putid, t));
      setCurrentIndex([]);
      setSelectedColour(null);
      setSelectedSupplier(null);
      setSelectedFilterColour(null);
      setType(null);
      await initialExicution();
      if (res) {
        setState((upState) => ({
          ...upState,
          loading: false,
          searchText: '',
        }));
      }
    } else {
      setState((postState) => ({
        ...postState,
        loading: true,
      }));
      const postParams = {
        devOrderId: devOrderID,
        additionalInformation: state.testAttribute[updateIndex].additionalInformation ? state.testAttribute[updateIndex].additionalInformation : '',
        code: state.testAttribute[updateIndex].code,
        description: state.testAttribute[updateIndex].description,
        minPassRate: state.testAttribute[updateIndex].minPassRate,
        type: state.testAttribute[updateIndex].type,
        bomComponent: showData.libId,
        colour: state.testAttribute[updateIndex].colour._id,
        testPrice: state.testAttribute[updateIndex].testPrice,
      };

      await dispatch(action.addProductTest(postParams, t));
      setCurrentIndex([]);
      setSelectedColour(null);
      setSelectedSupplier(null);
      setSelectedFilterColour(null);
      setType(null);
      await initialExicution();
      setState((postState) => ({
        ...postState,
        loading: false,
        searchText: '',
      }));
    }
  };

  const onNewEntery = async (newIndex) => {
    if (state?.testAttribute?.[newIndex]) {
      const test =
        isEmpty(state?.testAttribute?.[newIndex]?.code) ||
        isEmpty(state?.testAttribute?.[newIndex]?.description) ||
        isEmpty(state?.testAttribute?.[newIndex]?.minPassRate) ||
        isEmpty(state?.testAttribute?.[newIndex]?.type) ||
        state.testAttribute[newIndex].type === null ||
        isEmpty(state?.testAttribute?.[newIndex]?.colour) ||
        state?.testAttribute?.[newIndex]?.colour === null ||
        isEmpty(state?.testAttribute?.[newIndex]?.additionalInformation);
      if (test) {
        const newS = state.testAttribute.map((obj, i) => {
          if (i === newIndex) {
            return { ...obj, isEmpty: true };
          }
          return obj;
        });
        setState((initred) => ({
          ...initred,
          testAttribute: [...newS],
        }));
      }
    }
  };

  const forTypeArr = (item) => {
    return Array.isArray(item?.type) ? item?.type[0] : item?.type;
  };

  const handleEdit = async (item, i, childIndex) => {
    childIndex !== undefined ? setCurrentIndex([i, childIndex]) : setCurrentIndex([i]);
    setForEditId(item._id);
    const foundIndex = testingAttributes.findIndex((ele) => ele._id === item._id);
    setDesc(item && !isEmpty(item) ? item.description : state.testAttribute[i]?.description);
    setCode(item && !isEmpty(item) ? item?.code ?? '' : state.testAttribute[i]?.code ?? '');
    setAddInfo(item && !isEmpty(item) ? item?.additionalInformation : state.testAttribute[i]?.additionalInformation);
    setTestPrice(item && !isEmpty(item) ? item?.testPrice : state.testAttribute[i]?.testPrice);
    const typ = testTypeMaster.filter((ele) => ele._id === (!isEmpty(item) && fromTestingLib ? forTypeArr(item) : testingAttributes[i]?.type));
    const col = colourOptions.filter(
      (colele) => colele._id === (!Array.isArray(item?.colour) && fromTestingLib ? colourWasNotArray(item, foundIndex) : colourwasArray(item, foundIndex)),
    );
    const supp = supplierOptions.filter(
      (suppEle) =>
        suppEle._id === (!Array.isArray(item?.supplier) && fromTestingLib ? supplierWasNotArr(item, foundIndex) : supplierwasArray(item, foundIndex)),
    );
    setSelectedSupplier(supp[0]);
    setSelectedColour(col[0]);
    setType(...typ);
    setSavedEdit(false);
  };

  const supplierWasNotArr = (item, foundIndex) => {
    return item && !isEmpty(item) && fromTestingLib ? item?.supplier?._id : testingAttributes[foundIndex].supplier?._id;
  };

  const colourwasArray = (item, i) => {
    return item && Array.isArray(item.colour) ? colourwasArr(item, i) : testingAttributes[i]?.colour?._id;
  };

  const colourwasArr = (item, i) => {
    return item && !isEmpty(item) && fromTestingLib ? item?.colour[0]?._id : testingAttributes[i]?.colour?._id;
  };

  const colourWasNotArray = (item, foundIndex) => {
    return item && !isEmpty(item) && fromTestingLib ? item?.colour?._id : testingAttributes[foundIndex]?.colour?._id;
  };

  const supplierwasArray = (item, i) => {
    return item && Array.isArray(item.supplier) ? supplierWasNotArray(item, i) : testingAttributes[i]?.supplier?._id;
  };

  const supplierWasNotArray = (item, i) => {
    return item && !isEmpty(item) && fromTestingLib ? item?.supplier[0]?._id : testingAttributes[i]?.supplier?._id;
  };

  const handleRedotheStatus = (i) => {
    setReDoStatus(i);
    setShowConfirmationReDo(!showConfirmationReDo);
  };

  const iconsChange = () => {
    return sortTable.sortOrder === '' ? <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" /> : forAscandDesc();
  };

  const forAscandDesc = () => {
    return sortTable.sortOrder === 'Asc' || sortTable.sortOrder === '' ? (
      <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />
    ) : (
      <i className="icon-Table-Down font-weight-heavy text-black f-14 ml-1" />
    );
  };

  const handleChange = async (event, item) => {
    const fieldName = event?.currentTarget?.name;
    const value = event?.currentTarget?.value?.trim() ? event.currentTarget?.value : '';

    if (fieldName === 'description') {
      setDesc(value);
    } else if (fieldName === 'code') {
      setCode(value);
    } else if (fieldName === 'additionalInformation') {
      setAddInfo(value);
    } else if (fieldName === 'testPrice') {
      setTestPrice(value);
    }
    const newRow = [...testingAttributes];
    const index = newRow.findIndex((ind) => ind._id === item._id);
    newRow[index] = {
      ...newRow[index],
      [fieldName]: value,
      isEmpty:
        (fieldName === 'code' && value === '') ||
        (fieldName === 'description' && value === '') ||
        (fieldName === 'minPassRate' && value === '') ||
        (fieldName === 'additionalInformation' && value === ''),
    };
    await dispatch(action.updateProductBom(newRow));
  };

  const openForPreview = (prevIndex) => {
    setReportId(state.testAttribute[prevIndex]?.testReport?._id);
    setShowForPreview(true);
  };

  const handleSelectType = async (value, item) => {
    const copyState = [...state.testAttribute];
    let foundIndex = '';
    foundIndex = copyState.findIndex((ele) => ele._id === item._id);
    if (foundIndex >= 0) {
      copyState[foundIndex].type = value?._id;
      copyState[foundIndex].isEmpty = !value?.name;
      setState((typeState) => ({
        ...typeState,
        testAttribute: copyState,
      }));
      setType(value);
      await dispatch(action.updateProductBom(copyState));
    }
  };

  const handleSelectColour = async (value, item) => {
    const copyState = [...state.testAttribute];
    setSelectedColour(value);
    let foundIndex = '';
    foundIndex = copyState.findIndex((ele) => ele._id === item._id);
    if (foundIndex >= 0) {
      copyState[foundIndex].colour = value;
      copyState[foundIndex].isEmpty = !value;
      setState((colourState) => ({
        ...colourState,
        testAttribute: [...copyState],
      }));
      await dispatch(action.updateProductBom(copyState));
    }
  };

  const handleSelectSupplier = async (value, item) => {
    const copyState = [...state.testAttribute];
    setSelectedSupplier(value);
    let foundIndex = '';
    foundIndex = copyState.findIndex((ele) => ele._id === item._id);
    if (foundIndex >= 0) {
      copyState[foundIndex].supplier = value;
      copyState[foundIndex].isEmpty = !value;
      setState((supState) => ({
        ...supState,
        testAttribute: [...copyState],
      }));
      await dispatch(action.updateProductBom(copyState));
    }
  };

  const handleRenew = (renewItem, renewIndex) => {
    setReNewState((prevRenewState) => ({
      prevRenewState,
      documentLibId: [state?.testAttribute[renewIndex]?.libId],
      reportIds: Array.isArray(renewItem?.testReport) ? [renewItem?.testReport[0]?._id] : [renewItem?.testReport?._id],
      renewName: state?.testAttribute[renewIndex]?.testReport?.pdfTitle,
      renewStatus: [state?.testAttribute[renewIndex]?.status],
      testIds: [state?.testAttribute[renewIndex]?._id],
      showDropZone: true,
    }));
    setFromRenew(true);
    setpdfModal(true);
  };

  const showCreatedandModified = (item) => {
    return (
      (item?.createdBy || item?.modifiedBy) && (
        <div className="common-table-info-container right">
          <button type="button" aria-label="Library" className="btn btn-info-hover">
            <span className="icon icon-Information f-20" />
            <span className="text">Info</span>
          </button>
          <div className="information">
            {item?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.CREATED')}</strong> :
                {`${item?.createdBy?.firstName} ${item?.createdBy?.lastName} | `}
                {moment(item?.createdAt).format('DD-MMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.createdBy?.name && (
              <p className="text-left m-0">
                <strong>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.CREATED')}</strong> :{`${item?.createdBy?.name} | `}
                {moment(item?.createdAt).format('DD-MMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.modifiedBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.MODIFIED')}</strong> :
                {`${item?.modifiedBy?.firstName} ${item?.modifiedBy?.lastName} | `}
                {moment(item?.updatedAt).format('DD-MMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.modifiedBy?.name && (
              <p className="text-left m-0">
                <strong>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.MODIFIED')}</strong> :{`${item?.modifiedBy?.name} | `}
                {moment(item?.updatedAt).format('DD-MMM-YYYY, h:mm a')}
              </p>
            )}
          </div>
        </div>
      )
    );
  };

  const showStatusBtn = (ele, index) => {
    return (
      (ele.status !== 'Pending' || ele.status) && (
        <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.CLEAR_STAUS')}>
          <button
            className="btn"
            onClick={() => handleRedotheStatus(index)}
            aria-label="clear status"
            type="button"
            disabled={ele?.status === 'Pending' || !ele?.status}
          >
            <span className="icon icon-Clear-New f-20" />
            <span className="text">{t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TESTING.CLEAR_STATUS')}</span>
          </button>
        </CustomTooltip>
      )
    );
  };
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const handleToggle = (rowId, nextShow) => {
    setOpenPopoverId((currentId) => {
      // If closing the current popover, set to null
      if (!nextShow && currentId === rowId) {
        return null;
      }
      // If opening a new popover, set its ID
      if (nextShow) {
        return rowId;
      }
      return currentId; // No change for other scenarios
    });
  };

  const actionButtons = (item, i, childIndex) => {
    return (currentIndex[0] === i && item._id === forEditId) || !item._id ? (
      <>
        <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SAVE')}>
          <button className="btn p-0" onClick={() => handleSave(item, i, childIndex)} type="button" aria-label="Save">
            <span className="icon-Save-1 text-grey f-24" />
          </button>
        </CustomTooltip>
        <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.CANCEL')}>
          <button className="btn p-0" onClick={() => handleCancle(i)} type="button" aria-label="close">
            <span className="icon-close text-grey f-20" />
          </button>
        </CustomTooltip>
      </>
    ) : (
      <>
        <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.EDIT')}>
          <button className="btn p-0" onClick={() => handleEdit(item, i, childIndex)} type="button" aria-label="Edit">
            <span className="icon-Edit-1 text-grey f-20" />
          </button>
        </CustomTooltip>

        <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.DELETE')}>
          <button className="btn p-0" aria-label="delete" onClick={() => handleDelete(item._id)} type="button">
            <span className="icon-Delete text-grey f-20" />
          </button>
        </CustomTooltip>
        <button type="button" className="btn p-0">
          <OverlayTrigger
            placement="left"
            trigger="click"
            rootClose
            onToggle={(nextShow) => handleToggle(i, nextShow)}
            overlay={
              <Popover className="table-action-popup">
                <Popover.Content>
                  <ul>
                    <li>
                      <button className="btn" onClick={() => handleAddToLibrary(item)} type="button" aria-label="Library">
                        <span className="icon icon-Library-1 f-20" />
                        <span className="text">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.ADD_LIBRARY')}</span>
                      </button>
                    </li>
                    <li>
                      <button className="btn" onClick={() => handleRenew(item, i)} disabled={testReportWasArray(item)} type="button" aria-label="renew">
                        <span className="icon icon-Update-1 f-20" />
                        <span className="text">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.RENEW')}</span>
                      </button>
                    </li>
                    <li>{showStatusBtn(item, i)}</li>
                    <li>{previewUpload(item, i)}</li>
                    {item?.createdBy && <li>{showCreatedandModified(item)}</li>}
                  </ul>
                </Popover.Content>
              </Popover>
            }
          >
            <i className={`icon ${openPopoverId === i ? 'icon-close f-20' : 'icon-More f-20'}`} />
          </OverlayTrigger>
        </button>
      </>
    );
  };

  const previewUpload = (item, i) => {
    if (!Array.isArray(item.testReport)) {
      return item.testReport === null ? (
        <button className="btn" onClick={() => openModal(item, i)} type="button" aria-label="upload">
          <span className="icon-Upload-1 f-24 text-grey" />
          <span className="text">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.UPLOAD')}</span>
        </button>
      ) : (
        <button className="btn" onClick={() => openForPreview(i)} type="button" aria-label="preview">
          <span className="icon-Preview-Document f-24 text-grey" />
          <span className="text">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.PREVIEW')}</span>
        </button>
      );
    }
    return item.testReport[0] === null ? (
      <button
        className="btn"
        aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.UPLOAD')}
        onClick={() => openModal(item, i)}
        type="button"
      >
        <span className="icon icon-Upload-1 f-24 text-grey" />
        <span className="text">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.UPLOAD')}</span>
      </button>
    ) : (
      <button className="btn" onClick={() => openForPreview(i)} aria-label="preview" type="button">
        <span className="icon-Preview-Document f-24 text-grey" />
        <span className="text">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.PREVIEW')}</span>
      </button>
    );
  };

  const handleAddToLibrary = (forLibItem) => {
    setCodeToSendLibrary(forLibItem?.code);
    setShowAddToLibraryModal(true);
  };

  const toggleAddToLibrary = () => {
    setCodeToSendLibrary('');
    setShowAddToLibraryModal(false);
  };

  const submitToLibrary = async (codeData) => {
    const dataToSubmit = state.testAttribute?.filter((codeEle) => codeEle.code === codeToSendLibrary);
    const paramsForCode = {
      additionalInformation: dataToSubmit[0].additionalInformation,
      bomComponent: dataToSubmit[0]?.libId,
      code: codeData,
      colour: dataToSubmit[0]?.colour?._id,
      supplier: dataToSubmit[0]?.supplier?._id, // Supplier
      description: dataToSubmit[0]?.description,
      image: dataToSubmit[0]?.image,
      loggedInUserId,
      minPassRate: dataToSubmit[0]?.minPassRate,
      type: dataToSubmit[0].type,
      libId: dataToSubmit[0].libId,
      _id: dataToSubmit[0]._id,
      testPrice: dataToSubmit[0]?.testPrice || '0',
    };
    setState((prevAddState) => ({
      ...prevAddState,
      loading: true,
    }));
    const res = await dispatch(action.sendCodetoLibrary(paramsForCode, devOrderID, t));
    res &&
      setState((prevAddState) => ({
        ...prevAddState,
        loading: false,
      }));
    toggleAddToLibrary();
  };
  const testReportWasArray = (ele) => {
    return Array.isArray(ele.testReport) ? ele.testReport[0] === null || isEmpty(ele.testReport[0]) : ele.testReport === null || isEmpty(ele.testReport);
  };

  const openModal = (parItem, parId) => {
    if (parId !== null) {
      setReNewState((singleUp) => ({
        singleUp,
        documentLibId: [state.testAttribute[parId]?.libId],
        reportIds: Array.isArray(parItem?.testReport) ? [parItem?.testReport[0]?._id] : [parItem?.testReport?._id],
        // reportIds:  [state.testAttribute[parId]?.testReport?._id],
        renewName: '',
        renewStatus: [state.testAttribute[parId]?.status],
        testIds: [state.testAttribute[parId]?._id],
        showDropZone: true,
      }));
    } else {
      const libids = [];
      const repoId = [];
      const tesId = [];
      const statusEle = [];
      selectedIdArray &&
        !isEmpty(selectedIdArray) &&
        selectedIdArray.forEach((sEle) => {
          state.testAttribute.forEach((allEle) => {
            if (allEle._id === sEle) {
              libids.push(allEle.libId);
              repoId.push(Array.isArray(allEle?.testReport) ? allEle?.testReport[0]?._id : allEle?.testReport?._id);
              tesId.push(allEle._id);
              statusEle.push(allEle.status);
            }
          });
        });
      setReNewState((multipleUp) => ({
        ...multipleUp,
        documentLibId: [...libids],
        reportIds: [...repoId],
        renewName: '',
        renewStatus: [...statusEle],
        testIds: [...tesId],
        showDropZone: true,
      }));
    }
    setpdfModal(true);
  };

  const handleApproval = async (data) => {
    const commentParams = {
      devOrderId: data[0],
      statusData: {
        comment: data[1].comment,
        status: data[1].status === '1',
        selectedDate: data[1].commentDate,
        result: data[1].result,
      },
      testCaseIds: selectedIdArray,
    };
    const commetnId = devOrderID;
    await dispatch(action.approveRejectComment(commentParams, commetnId, t));
    setSelectedIdArray([]);
    setSelectAll(false);
    await initialExicution();
  };

  const togglePdfModal = async () => {
    setpdfModal(false);
    setFromRenew(false);
    if (!renewState.showDropZone) {
      await dispatch(action.fetchReportList({ id: devOrderID }));
    } else {
      await initialExicution();
    }
    setReNewState((clearState) => ({
      clearState,
      documentLibId: [],
      reportIds: [],
      renewName: '',
      renewStatus: [],
      testIds: [],
      showDropZone: true,
    }));
    setExpectedExpairy('');
    setSelectedIdArray([]);
  };

  const handleSelectedOption = async (event) => {
    if (!fromTestingLib) {
      event.colour = null;
      const addtoTestParams = {
        devOrderId: devOrderID,
        testLibId: event._id,
        bomComponentId: showData._id,
        bomComponentLibId: showData.libId,
      };
      await dispatch(action.newPostApi(addtoTestParams, t));
      setShowNewRow(false);
      setCurrentIndex([]);
      await initialExicution();
    }
    setShowNewRow(false);
  };

  const forFilter = async (val, eve) => {
    switch (val) {
      case 'op1':
        setSelectedType(eve);
        break;
      case 'op2':
        setSelectedFilterColour(eve);
        break;
      case 'clear': {
        setSelectedFilterColour(null);
        setSelectedType(null);
        const getAttributes = {
          devOrderId: devOrderID,
          bomComponent: showData.libId,
          bomcomponentLibId: showData.libId,
        };
        await dispatch(action.fetchProductBomTesting(getAttributes));
        break;
      }
      default: {
        const paramsforfilter = {
          testType: selectedType?._id,
          colour: selectedFilterColour?._id,
        };
        setShowNewRow(false);
        onSumbit(paramsforfilter);
        break;
      }
    }
  };

  const onSubmitFilter = async (filterParams) => {
    const params = {
      testCode: selectedTypeTop.code,
      bomComponent: showData?._id,
      colour: colour?._id ? colour._id : null,
      supplier: supplier?._id ? supplier?._id : null,
      pageIndex: 1,
      pageSize: state.pageSize,
      ...filterParams,
    };
    setState((deleteState) => ({
      ...deleteState,
      filterParams,
    }));
    await dispatch(action.fetchTestReportList(params));
  };

  const forLibFilter = async (val, eve) => {
    switch (val) {
      case 'op1':
        setSelectedBrand(eve);
        break;
      case 'op2':
        setSelectedSeason(eve);
        break;
      case 'op3':
        setSelectedYear(eve);
        break;
      case 'op4':
        setSelectedMonth(eve);
        break;
      case 'clear': {
        setSelectedBrand(null);
        setSelectedSeason(null);
        setSelectedYear(null);
        setSelectedMonth(null);
        const clearFilter = {
          brandId: null,
          seasonId: null,
          year: null,
          month: null,
          supplierId: null,
        };
        await onSubmitFilter(clearFilter);
        break;
      }
      default: {
        const paramsforfilter = {
          brandId: selectedBrand?._id,
          seasonId: selectedSeason?._id,
          year: selectedYear?.name,
          month: selectedMonth?.name,
          supplierId: supplier?._id,
        };
        onSubmitFilter(paramsforfilter);
        break;
      }
    }
  };

  const onSumbit = async (params) => {
    const getAttributes = {
      devOrderId: devOrderID,
      bomComponent: showData.libId,
      bomcomponentLibId: showData.libId,
      ...params,
    };
    await dispatch(action.fetchProductBomTesting(getAttributes));
  };

  const removeNewRow = () => {
    setShowNewRow(!showNewRow);
    setCurrentIndex([]);
  };

  const hideNewRow = () => {
    return (
      <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.CANCEL')}>
        <button className="btn" onClick={() => removeNewRow()} aria-label="close" type="button">
          <span className="icon icon-close f-20" />
        </button>
      </CustomTooltip>
    );
  };

  const handleSelectedTest = (e) => {
    setSelectedTypeTop(e);
  };

  const ids = () => (showNewRow ? 'testingAttribute' : 'hideBomTesting');
  const dataToshow = () => {
    return fromTestingLib ? (
      <ImportedDataTable
        handleSelectAll={handleSelectAll}
        isSelectAll={isSelectAll}
        selectedIdArray={selectedIdArray}
        allImportedTest={state.testAttribute}
        onSortColumn={onSortColumn}
        sortTable={sortTable}
        iconsChange={iconsChange}
        isSupplierLoggedIn={isSupplierLoggedIn}
        isProductArchived={isProductArchived}
        isLoading={state.loading}
        onSelectCheckBox={onSelectCheckBox}
        showNewRow={showNewRow}
        handleCancle={handleCancle}
        showData={selectedTypeTop}
        showParentData={showData}
        handleDelete={handleDelete}
        fromTestLib={fromTestingLib}
        hanldeUpdate={hanldeUpdate}
        fromProductBom={fromProductBom}
        selectedSupplier={supplier}
        selectedColour={colour}
        removeNewRow={removeNewRow}
      />
    ) : (
      <div className="table-responsive flex-fill" id={ids()}>
        <Tabels
          handleSelectAll={handleSelectAll}
          isSelectAll={isSelectAll}
          allTests={state.testAttribute}
          onSortColumn={onSortColumn}
          sortTable={sortTable}
          iconsChange={iconsChange}
          onSelectCheckBox={onSelectCheckBox}
          currentIndex={currentIndex}
          savedEdit={savedEdit}
          type={type}
          types={types}
          selectedIdArray={selectedIdArray}
          handleChange={handleChange}
          desc={desc}
          handleSelectType={handleSelectType}
          addInfo={addInfo}
          code={code}
          testPrice={testPrice}
          actionButtons={actionButtons}
          handleEdit={handleEdit}
          forEditId={forEditId}
          supplierOptions={supplierOptions}
          selectedSupplier={selectedSupplier}
          bomOptions={bomOptions}
          handleSelectColour={handleSelectColour}
          colourOptions={colourOptions}
          selectedColour={selectedColour}
          ReportList={ReportList}
          isLoading={state.loading}
          showNewRow={showNewRow}
          hideBom
          forNewOptions={forNewOptions}
          handleSelectedOption={handleSelectedOption}
          cancleBtn={hideNewRow}
          handleExpand={handleExpand}
          handleSelectSupplier={handleSelectSupplier}
          newArrayWithData={newArrayWithData}
          expandAllData={expandAllData}
          indexes={indexes}
          parentIndexes={parentIndexes}
          count={count}
          setForEditId={setForEditId}
          fromBom
        />
      </div>
    );
  };

  const handleSelectedSupplier = (e) => {
    setSupplier(e);
  };

  const handleSelectedColour = (e) => {
    setColour(e);
  };

  const handleDownload = async () => {
    if (fromTestingLib) {
      await dispatch(
        action.downloadTestingAttribute(
          {
            testCode: selectedTypeTop.code,
            isProduct: false,
            bomComponent: showData?._id,
            colour: colour?._id ? colour._id : null,
            supplier: supplier?._id ? supplier?._id : null,
            ...state?.filterParams,
            sortOrder: state?.sortBy,
            searchText: state?.searchText || '',
          },
          t,
        ),
      );
    } else {
      await dispatch(
        action.downloadProductTestingAttribute(
          {
            testCode: showData.referenceCode,
            devOrderId: devOrderID,
            bomcomponentLibId: showData.libId,
            bomComponent: showData?._id,
            colour: selectedFilterColour || null,
            supplier: supplier?._id ? supplier?._id : null,
            testType: selectedType || null,
            ...state?.sortBy,
            searchText: state?.searchText || '',
          },
          t,
        ),
      );
    }
  };

  const showFilters = () => {
    return !fromTestingLib ? (
      <FilterBy
        onBtnClick={forFilter}
        placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECT_TEST_TYPE')}
        noOption="No test type Available"
        placeholder2={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECT_COLOUR')}
        noOption2="No colours available"
        selectedItem2={selectedFilterColour}
        selectedItem1={selectedType}
        newVisual
      />
    ) : (
      <FilterBy
        onBtnClick={forLibFilter}
        placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECT_BRAND')}
        noOption="No brand data available"
        placeholder2={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECT_SEASON')}
        noOption2="No season data available"
        placeholder4={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECT_MONTH')}
        noOption4="No months available"
        placeholder3={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECT_YEAR')}
        noOption3="No year available"
        selectedItem1={selectedBrand}
        selectedItem2={selectedSeason}
        selectedItem3={selectedYear}
        selectedItem4={selectedMonth}
        isDisable={isEmpty(state.testAttribute)}
        newVisual
      />
    );
  };

  return (
    <>
      <Modal
        className={
          !fromTestingLib
            ? 'relative-width-modal new-testing-body common-custom-modal modal-medium-4x supplier-overview-modal color-way-modal'
            : 'relative-width-modal new-testing-body common-custom-modal modal-medium-4x supplier-overview-modal color-way-modal moda-fullpage'
        }
        size="lg"
        show={onOpen}
        onHide={toggleTestReq}
        backdrop="static"
      >
        <Modal.Header className="modal-header-custom">
          <Modal.Title className="f-16 text-left">
            {t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.TESTING_ATTRIBUTES')} {showData?.referenceCode}{' '}
            {devOrderID && `(${productDetails?.number})`}
          </Modal.Title>
          <span onClick={() => toggleTestReq()} className="icon-close f-20 cursor-pointer" />
        </Modal.Header>
        <Modal.Body className="formodalFooter  pb-0">
          {state.loading ? (
            <Loader />
          ) : (
            <>
              <div className="bom-list">
                {fromTestingLib && (
                  <TopTable
                    showData={showData}
                    handleSelectedTest={handleSelectedTest}
                    selectedType={selectedTypeTop}
                    handleSelectedSupplier={handleSelectedSupplier}
                    supplier={supplier}
                    handleSelectedColour={handleSelectedColour}
                    colour={colour}
                    fromTestingLib={fromTestingLib}
                    devOrderID={devOrderID}
                    state={state}
                    setSupplier={setSupplier}
                    setColour={setColour}
                    TestingDeleteAccess={TestingDeleteAccess}
                    testTypeMaster={testTypeMaster}
                  />
                )}
                <div className="filter-container modal-search mb-24">
                  <div className="title-search-container search-icon-enable ml-0 pl-0 pr-0">
                    <input
                      onChange={(e) => handleSearch(e)}
                      name="search"
                      type="text"
                      className="form-control text-bordered "
                      value={state.searchText}
                      placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SEARCH_TESTING_ATTRIBUTE')}
                    />
                    <span className="icon-search" />
                  </div>
                  <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.ADD_NEW_TEST')}>
                    <button
                      className="btn btn-outline common-btn"
                      aria-label="Add"
                      type="button"
                      onClick={addNewTest}
                      disabled={fromTestingLib && !selectedTypeTop}
                    >
                      <span className="icon-Add f-24" />
                    </button>
                  </CustomTooltip>

                  <span title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.FILTER')}>{showFilters()}</span>
                  <CustomTooltip placement="top" tooltipText={t('FILTER.DOWNLOAD')}>
                    <button
                      className="btn btn-outline common-btn"
                      type="button"
                      onClick={handleDownload}
                      aria-label={t('FILTER.DOWNLOAD')}
                      disabled={isEmpty(state.testAttribute)}
                    >
                      <i className="icon-Download1 f-22" />
                    </button>
                  </CustomTooltip>
                  {fromTestingLib && (
                    <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.UPDATE_TEST')}>
                      <button
                        className="btn btn-outline common-btn"
                        aria-label="update"
                        type="button"
                        onClick={(e) => hanldeUpdate(e, null)}
                        disabled={isEmpty(selectedIdArray)}
                      >
                        <span className="icon-new-renew" />
                      </button>
                    </CustomTooltip>
                  )}
                  <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.MULTI_DELETE')}>
                    <button
                      className="btn btn-outline common-btn"
                      aria-label="Add"
                      type="button"
                      onClick={() => deleteColourType(null)}
                      disabled={isEmpty(selectedIdArray)}
                    >
                      <span className="icon-Delete f-24" />
                    </button>
                  </CustomTooltip>
                </div>
              </div>
              {dataToshow()}
            </>
          )}
        </Modal.Body>
        {!fromTestingLib && (
          <div className="show-borders">
            <NewApproveRejectFooter
              devOrderId={devOrderID}
              onSave={(...data) => handleApproval(data)}
              selectedIdArray={selectedIdArray}
              fromProductTesting
              fromModal
              btnsDisable={isEmpty(selectedIdArray)}
              status_0="modalStatus_0"
              status_1="modalStatus_1"
            />
          </div>
        )}
      </Modal>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          loading={state.loading}
          title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.DELETE_TESTING_ATTRIBUTE')}
          message={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.DELETE_MESSAGE')}
          secondMessage={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SECOND_MESSAGE')}
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
          showCheckBox
        />
      )}
      {showAddToLibraryModal && (
        <AddToLibrary
          onOpen={showAddToLibraryModal}
          Toggle={toggleAddToLibrary}
          showLoader={state.loading}
          codeName={codeToSendLibrary}
          submitCode={submitToLibrary}
        />
      )}
      {showConfirmationReDo && (
        <ConfirmationPopup
          onOpen={showConfirmationReDo}
          onConfirm={undoStatus}
          loading={state.loading}
          title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.STATE_CHANGE_CONFIRMATION')}
          message={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.SELECTED_STATUS_MESSAGE')}
          secondMessage={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.ATTRIBUTES_TESTING.DELETE_SECOND_MESSAGE')}
          toggle={() => setShowConfirmationReDo(!showConfirmationReDo)}
        />
      )}
      {pdfModal && (
        <UploadTesting
          onOpen={pdfModal}
          toggle={togglePdfModal}
          isRenewMode={fromRenew}
          documentIds={renewState.documentLibId}
          reportIds={renewState.reportIds}
          testIds={renewState.testIds}
          fromTestLib={fromTestingLib}
          renewName={renewState.renewName}
          expairyDate={expectedExpairy}
          showDropZone={renewState.showDropZone}
          status={renewState.renewStatus}
          showData={fromTestingLib && showData}
        />
      )}
      {showForPreview && (
        <ForPreview
          onOpen={showForPreview}
          toggle={() => {
            setShowForPreview(!showForPreview);
            setReNewState((initState) => ({
              initState,
              documentLibId: [],
              reportIds: [],
              renewName: '',
              renewStatus: [],
              testIds: [],
              showDropZone: true,
            }));
            setSelectedIdArray([]);
          }}
          devOrderId={devOrderID}
          reportId={reportId}
        />
      )}
    </>
  );
}

export default TestingAttributes;
